<template>
  <div id="loader">
    <template v-if="type === 'line'">
      <div class="line-spinner">
        <div class="bounce1" :style="{ backgroundColor: color || '#9e9e9e' }"></div>
        <div class="bounce2" :style="{ backgroundColor: color || '#9e9e9e' }"></div>
        <div class="bounce3" :style="{ backgroundColor: color || '#9e9e9e' }"></div>
      </div>
    </template>
    <template v-else-if="type === 'square'">
      <div class="spinner">
        <app-icon
          :name="icon"
          size="normal"
          v-if="icon"
          :color="color"/>
        <div class="cube1" :style="{ backgroundColor: color || '#9e9e9e' }"></div>
        <div class="cube2" :style="{ backgroundColor: color || '#9e9e9e' }"></div>
      </div>
    </template>
  </div>
</template>

<script>
import AppIcon from '@/components/icons/AppIcon.vue';

export default {
  name: 'Loader',
  components: {
    AppIcon,
  },
  props: {
    type: String,
    icon: String,
    color: String,
  },
};
</script>


<style lang="sass" scoped>
// --- LINE_LOADER ---------
.line-spinner
  align-items: center
  display: flex
  justify-content: flex-start
  text-align: center

.line-spinner > div
  width: 13px
  height: 13px
  margin-right: 3px

  border-radius: 100%
  display: inline-block
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both
  animation: sk-bouncedelay 1.4s infinite ease-in-out both

.line-spinner .bounce1
  -webkit-animation-delay: -0.32s
  animation-delay: -0.32s

.line-spinner .bounce2
  -webkit-animation-delay: -0.16s
  animation-delay: -0.16s

@-webkit-keyframes sk-bouncedelay
  0%, 80%, 100%
    -webkit-transform: scale(0)
  40%
    -webkit-transform: scale(1.0)

@keyframes sk-bouncedelay
  0%, 80%, 100%
    -webkit-transform: scale(0)
    transform: scale(0)
  40%
    -webkit-transform: scale(1.0)
    transform: scale(1.0)

// --- SQUARE_LOADER ---------
.spinner
  align-items: center
  display: flex
  justify-content: center
  width: 170px
  height:170px
  position: relative

.cube1, .cube2
  border-radius: 1.5px
  width: 17px
  height: 17px
  position: absolute
  top: 0
  left: 0

  -webkit-animation: sk-cubemove 2s infinite ease-in-out
  animation: sk-cubemove 2s infinite ease-in-out

.cube2
  -webkit-animation-delay: -1s
  animation-delay: -1s

@-webkit-keyframes sk-cubemove
  25%
    -webkit-transform: translateX(153px) rotate(-90deg) scale(0.5)
  50%
    -webkit-transform: translateX(153px) translateY(153px) rotate(-180deg)
  75%
    -webkit-transform: translateX(0px) translateY(153px) rotate(-270deg) scale(0.5)
  100%
    -webkit-transform: rotate(-360deg)

@keyframes sk-cubemove
  25%
    transform: translateX(153px) rotate(-90deg) scale(0.5)
    -webkit-transform: translateX(153px) rotate(-90deg) scale(0.5)
  50%
    transform: translateX(153px) translateY(153px) rotate(-179deg)
    -webkit-transform: translateX(153px) translateY(153px) rotate(-179deg)
  50.1%
    transform: translateX(153px) translateY(153px) rotate(-180deg)
    -webkit-transform: translateX(153px) translateY(153px) rotate(-180deg)
  75%
    transform: translateX(0px) translateY(153px) rotate(-270deg) scale(0.5)
    -webkit-transform: translateX(0px) translateY(153px) rotate(-270deg) scale(0.5)
  100%
    transform: rotate(-360deg)
    -webkit-transform: rotate(-360deg)
</style>
